const BASE_URL = 'https://notes-api.dicoding.dev/v2';

async function request(path, options = {}) {
  const url = `${BASE_URL}${path}`;
  const res = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
    ...options,
  });

  let json;
  try {
    json = await res.json();
  } catch (e) {
    throw new Error('Invalid JSON response');
  }

  if (!res.ok) {
    const message = (json && (json.message || JSON.stringify(json))) || 'Request failed';
    throw new Error(message);
  }

  if (json.data) return json.data;
  return json;
}

export async function getAllNotes() {
  const data = await request('/notes');
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.notes)) return data.notes;
  if (Array.isArray(data.data)) return data.data;
  return data;
}

export async function createNote(note) {
  const payload = JSON.stringify(note);
  const data = await request('/notes', { method: 'POST', body: payload });
  return data;
}

export async function deleteNote(id) {
  const data = await request(`/notes/${id}`, { method: 'DELETE' });
  return data;
}

export async function getNote(id) {
  const data = await request(`/notes/${id}`);
  if (data && data.id) return data;
  if (data && data.data) return data.data;
  return data;
}

export async function archiveNote(id) {
  const data = await request(`/notes/${id}/archive`, { method: 'POST' });
  return data;
}

export async function unarchiveNote(id) {
  const data = await request(`/notes/${id}/unarchive`, { method: 'POST' });
  return data;
}

export async function getArchivedNotes() {
  const data = await request('/notes/archived');
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.notes)) return data.notes;
  if (Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : [];
}
